// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { RegistrarService } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Registrar';
import { ERR_ARC_INST_CONF, SUC_ARC_INST_CONF } from '../../../../utils/strings';

const useArchiveInstrumentConfiguration = () => {
  return useExerciseSubmission(
    RegistrarService.RegistrarService_ArchiveInstrumentConfiguration,
    SUC_ARC_INST_CONF,
    ERR_ARC_INST_CONF,
  );
};

export default useArchiveInstrumentConfiguration;
